module.exports = __webpack_public_path__ + "static/media/ljubljana-12.8b74ae4f.jpg";